import React from "react";
import styled from "styled-components";

const Header = () => {
  return (
    <div>
      <HeroSection className="light hero">
        <div className="heroInner">
          <span>
            <h1 className="text-xl md:text-5xl text-white">YEŞİL DÖNÜŞÜM VE SÜRDÜRÜLEBİLİRLİK MERKEZİ</h1>
            <p className="mt-4 text-sm md:text-xl text-white">
              Organize Sanayi Bölgelerine (OSB) yeşil dönüşümde rehberlik ediyor, sürdürülebilirlik alanında sağlam
              adımlarla ilerleyen bir topluluk inşa ediyoruz.
            </p>
          </span>
        </div>
      </HeroSection>
    </div>
  );
};

export default Header;

const HeroSection = styled.section`
  position: relative;
  background:
    linear-gradient(to bottom, rgba(10, 12, 44, 0.75) 0%, rgba(10, 12, 44, 0.4) 60%, rgba(10, 12, 44, 0.8) 100%),
    url(images/landing-page/hero1.png);
  background-position: center;
  background-size: cover;
  color: #fafafc;
  padding: 8rem 2rem 5rem;

  .heroInner {
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: 1100px;
    margin: 0 auto;
    position: relative;
    z-index: 2;
    text-align: center;
    padding: 0 1rem;
  }

  h1 {
    font-weight: 800;
    text-shadow: 0 2px 12px rgba(0, 0, 0, 0.5);
    letter-spacing: -0.01em;
  }

  p {
    line-height: 1.6;
    max-width: 850px;
    margin-top: 1rem;
    text-shadow: 0 1px 8px rgba(0, 0, 0, 0.5);
  }

  @media (max-width: 768px) {
    padding: 6rem 1rem 3.5rem;

    h1 {
      font-size: 1.75rem;
      line-height: 1.25;
    }

    p {
      font-size: 1rem;
      line-height: 1.5;
      margin-top: 0.75rem;
    }
  }

  @media (max-width: 576px) {
    padding: 5rem 1rem 3rem;

    h1 {
      font-size: 1.5rem;
    }

    p {
      font-size: 0.9rem;
    }
  }
`;
